import React, { useEffect, useState } from "react";
import "./orders.css";
import { deleteOrders, getOrders } from "../../Data/Orders";
import OrderProductsComponent from "./orderProductsComponent";
import { useReactToPrint } from "react-to-print";

function Orders() {
  const [openMoreItems, setOpenMoreItems] = useState(false);
  const [orderItems, setOrderItems] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      const OrdersCollect = await getOrders();
      setOrderItems(
        OrdersCollect.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };

    return fetchOrders();
  }, [orderItems]);

  return (
    <div className="order_page">
      <h2>
        <center>Orders Place</center>
      </h2>
      <hr height="10px" />
      {orderItems.map((items, index) => {
        return (
          <>
            <br />
            <OrderProductsComponent items={items} key={index} />
          </>
        );
      })}
    </div>
  );
}

export default Orders;
